(function ($, app) {
	app.videoArchive = function (element) {
		const button = element.querySelector('.js-button');
		const amount = element.dataset.amount;
		const videos = Array.from(element.querySelectorAll('.js-video'));

		let hiddenVideos = Array.from(videos).filter((video) =>
			video.hasAttribute('hidden'),
		);

		const handleClick = async () => {
			await hiddenVideos.forEach((video, index) => {
				if (index < amount) {
					video.firstElementChild.style.animationDelay = `${index * 0.1}s`;
					video.removeAttribute('hidden');
				}
			});

			hiddenVideos[0].querySelector('a').focus();

			hiddenVideos = hiddenVideos.filter((video) =>
				video.hasAttribute('hidden'),
			);

			if (hiddenVideos.length === 0) {
				button.style.display = 'none';
			}
		};

		button.addEventListener('click', handleClick);
	};
})(jQuery, (window.app = window.app || {}));
